/**
 * Shared inline style tokens for the storefront pages.
 *
 * Vanilla CSS (no MUI) — the customer-facing storefront shouldn't carry
 * the dashboard's MUI runtime. Every storefront page imports these so a
 * design tweak is one edit.
 */

export const SHELL = {
  minHeight: '100vh',
  background: '#f8fafc',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", Roboto, sans-serif',
  color: '#0f172a',
};

export const MAX = { maxWidth: 1100, margin: '0 auto', padding: '24px 20px' };

export const CARD = {
  background: '#fff',
  borderRadius: 14,
  boxShadow: '0 10px 30px -15px rgba(15,23,42,0.15)',
  padding: 20,
  border: '1px solid #f1f5f9',
};

export const BUTTON = (color = '#422AFB', inverse = false) => ({
  background: inverse ? '#fff' : color,
  color: inverse ? color : '#fff',
  border: `1px solid ${color}`,
  padding: '10px 18px',
  borderRadius: 10,
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
});

export const SUB_INPUT = {
  padding: '10px 12px',
  borderRadius: 8,
  border: '1px solid #d1d5db',
  fontSize: 14,
  outline: 'none',
  background: '#fff',
  width: '100%',
};

export const navLinkStyle = { fontSize: 14, fontWeight: 600, color: '#0f172a', textDecoration: 'none' };

/** Currency formatter — falls back to USD if the brand hasn't set one. */
export const formatMoney = (amount, currency) =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(Number(amount || 0));

/**
 * Brand routes resolve from either `/site/:brandRef/...` (platform host)
 * or bare `/...` (custom domain). brandPath returns the right form for
 * the current host without a `brandRef` URL param.
 */
export function brandPath(brand, suffix) {
  if (!brand?._id) return suffix;
  return `/site/${brand._id}${suffix}`;
}
